import React from "react";
import Head from "next/head";

/**
 * SearchPageHead component
 * Sets the meta tag for search page
 * @returns {React.ReactElement}
 */
const SearchPageHead = () => (
  <Head>
    <meta name="robots" content="noindex" />
  </Head>
);

export default SearchPageHead;
